/**
 * `/sign-up` route — Clerk-rendered sign-up form (RLY-013 AC #2).
 *
 * On a successful signup, Clerk's webhook fires `user.created`. The portal-api
 * `/webhooks/clerk` handler (RLY-013 backend half) auto-creates the tenant +
 * user + owner membership rows; once the session lands the user, the
 * `/api/v1/me` request returns the populated tenant context.
 */

import { SignUp } from "@clerk/clerk-react";

export function SignUpPage() {
  return (
    <main
      aria-label="Sign up"
      className="flex min-h-screen items-center justify-center bg-background p-8"
    >
      <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
    </main>
  );
}

export default SignUpPage;
